export interface VideoTutorialProps {
  onNext: () => void
  translate: (key: string) => string
  language: string
}

const VideoTutorial = ({ onNext, translate, language }: VideoTutorialProps) => {
  const normalizedLang = language.toLowerCase().startsWith('ru') ? 'ru' : 'en'

  const videoMap: Record<string, string> = {
    en: '/video/TutorialVideo_en.mp4?v=en',
    ru: '/video/TutorialVideo_ru.mp4?v=ru'
  }

  const videoSrc = videoMap[normalizedLang]

  return (
 <main
  className="flex flex-col items-center justify-between px-4 py-[13vh] w-full"
  style={{ height: "calc(var(--vh, 1vh) * 100)" }}
>
  {/* Video Section */}
  <section className="w-full max-w-2xl flex-1 flex items-center justify-center overflow-y-auto">
    <div className="w-full">
      <video
        key={normalizedLang}
        className="w-full h-auto max-h-[60vh] rounded-xl shadow-lg"
        controls
        autoPlay
        preload="metadata"
        playsInline
      >
        <source src={videoSrc} type="video/mp4" />
        <p>{translate("tutorial.video_screen.video_alt")}</p>
      </video>
    </div>
  </section>

  {/* Footer Button */}
  <footer className="w-full max-w-2xl flex-shrink-0 sticky bottom-0  px-0 py-2 md:py-3">
    <button
      type="button"
      onClick={onNext}
      className="w-full rounded-lg font-medium transition-colors duration-200 py-2
            bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-400 text-base md:text-lg lg:text-xl"
    >
      {translate("tutorial.video_screen.btn_text")}
    </button>
  </footer>
</main>
  )
}

export default VideoTutorial
